import React from 'react';
import "./FilterColorSelect.css";

const FilterColorSelect = ({ title, colors, setSelectedItems, selectedItems, addNode, removeNode, updateNode, path }) => {


    const handleOptionChange = (field_name, color) => {
        setSelectedItems((prev) => {
            const currentColors = prev[field_name] || [];

            // Update selected items based on whether the option is being added or removed
            const updatedColors = (!currentColors.includes(color))
                ? [...currentColors, color]
                : currentColors.filter((item) => item !== color);

            // Clone the path for use in tree management
            const fullPath = [...path, { key: field_name, value: 0 }];

            if ((!currentColors.includes(color))) {
               
                
                addNode(fullPath, { is_group: 0, "operation": "or", values: updatedColors });
            }
            else if (currentColors.includes(color) && updatedColors.length !== 0) {
     
                updateNode(fullPath, { is_group: 0, "operation": "or", values: updatedColors }, field_name);
            }
            else if (updatedColors.length === 0) {
                removeNode(fullPath);
            }

            // If `updatedColors` is empty, remove `field_name` from `selectedItems`
            if (updatedColors.length === 0) {
                const { [field_name]: _, ...rest } = prev;
                return rest;
            }
            return {
                ...prev,
                [field_name]: updatedColors,
            };
        });
    };



    return (
        <div className="color-container">
            {colors.map((color, index) => (
                <div
                    key={index}
                    className={`color-option ${selectedItems[title] && selectedItems[title].includes(color.name) ? 'selected' : ''}`}
                    style={{ backgroundColor: color.color }}
                    title={color.name}
                    onClick={() => handleOptionChange(title, color.name)}
                />
            ))}
        </div>
    );
}

export default FilterColorSelect;
